import Immutable from 'seamless-immutable';
import _ from 'lodash';

//the clone in _.clone(data) is needed as we need it to return a new clena instance of it
const getMutable = (data, opts = {}) => (Immutable.isImmutable(data) ? data.asMutable(opts) : _.clone(data));
/**
 * Create an blacklist from provided data
 */
function create(data = {}) {
  const result = _.clone(data);
  return Immutable(result, { prototype: model });
}

/**
 * Transform a blacklistModel into a frontend blacklist object
 * @param {blacklist} blacklist
 * @returns {Object}
 */
function deserialize(blacklist) {
  const result = _.pick(blacklist, _keys);

  result.blacklistDictionary = blacklist.blackListDictionary;

  return create(result);
}

/**
 * Transform a blacklist object into a backend blacklistModel object
 * @param {blacklist} blacklist
 * @returns {Object}
 */
function serialize(blacklist) {
  const result = getMutable(blacklist, { deep: true });

  result.blackListDictionary = blacklist.blacklistDictionary;

  return _.pick(result, _keys);
}

/** The blacklist prototype */
const model = {};

/**
 * An array of keys on the blacklist object that should be shared between the API requests and responses
 */
const _keys = ['blackListDictionary'];

export default {
  create,
  deserialize,
  serialize,
};
